import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedGames from './components/FeaturedGames';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { articles } from '@/mocks/articles';
import { aboutInfo, faqItems } from '@/mocks/about';
import { games, gameCategories } from '@/mocks/games';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '黄油网页游戏合集',
      url: typeof window !== 'undefined' ? window.location.origin : '',
      description: '免费在线畅玩黄油网页游戏合集，精选优质黄油网页游戏，无需下载即点即玩',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'contact@inthic.cn',
        contactType: 'customer service',
      },
    },
    {
      '@type': 'WebSite',
      name: '黄油网页游戏合集',
      url: typeof window !== 'undefined' ? window.location.origin : '',
      description: '免费在线畅玩黄油网页游戏合集',
      potentialAction: {
        '@type': 'SearchAction',
        'target': {
          '@type': 'EntryPoint',
          urlTemplate: typeof window !== 'undefined' ? `${window.location.origin}/category/{search_term}` : '',
        },
        'query-input': 'required name=search_term',
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqItems.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedGames />
        <CategorySection />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}